/// ///////////////////////////////////////////////////////////////////////////
//  Copyright (C) 2013 by sanpolo CO.LTD                                    //
//                                                                          //
//  This file is part of WIDE                                               //
//                                                                          //
//  You should have received a copy of the WIDE License along with this     //
//  program.  If not, see <http://www.wware.org/wide/license.html>.         //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// ///////////////////////////////////////////////////////////////////////////
// Created At : 2019-03-05T12:38:22.153Z by lizhutang (lizhutang@spolo.org)

'use strict'
export default [{
  name: '位置',
  buildProps: ['float', 'display', 'position', 'top', 'right', 'left', 'bottom'],
  properties: [{
    name: '浮动',
    property: 'float',
    type: 'radio',
    defaults: 'none',
    list: [
      { value: 'none', name: wwjs.i18n('无'), className: 'fa fa-times' },
      { value: 'left', name: wwjs.i18n('左浮动'), className: 'fa fa-align-left' },
      { value: 'right', name: wwjs.i18n('右浮动'), className: 'fa fa-align-right' }
    ]
  },
  { property: 'position', type: 'select' }
  ]
}, {
  name: wwjs.i18n('尺寸'),
  open: false,
  buildProps: ['width', 'flex-width', 'height', 'max-width', 'max-height', 'min-width', 'min-height', 'margin', 'padding'],
  properties: [{
    id: 'flex-width',
    type: 'integer',
    name: '宽度',
    units: ['px', '%'],
    property: 'flex-basis',
    toRequire: 1
  }, {
    name: '宽度',
    property: 'width'
  }, {
    name: '高度',
    property: 'height'
  }, {
    name: '最小宽度',
    property: 'min-width'
  }, {
    name: '最小高度',
    property: 'min-height'
  }, {
    name: '最大宽度',
    property: 'max-width'
  }, {
    name: '最大高度',
    property: 'max-height'
  }, {
    property: 'margin',
    name: '容器外边距(Margin)',
    properties: [
      { name: '上', property: 'margin-top' },
      { name: '下', property: 'margin-bottom' },
      { name: '左', property: 'margin-left' },
      { name: '右', property: 'margin-right' }
    ]
  }, {
    property: 'padding',
    name: '容器内边距(Padding)',
    properties: [
      { name: '上', property: 'padding-top' },
      { name: '下', property: 'padding-bottom' },
      { name: '左', property: 'padding-left' },
      { name: '右', property: 'padding-right' }
    ]
  }]
}, {
  name: '文字排版',
  open: false,
  buildProps: ['font-family', 'font-size', 'font-weight', 'letter-spacing', 'color', 'line-height', 'text-align', 'text-decoration', 'text-shadow'],
  properties: [
    { name: '字体', property: 'font-family' },
    { name: '文字粗细', property: 'font-weight' },
    { name: '文字颜色', property: 'color' },
    {
      property: 'text-align',
      name: '对齐方式',
      type: 'radio',
      defaults: 'left',
      list: [
        { value: 'left', name: '左对齐', className: 'fa fa-align-left' },
        { value: 'center', name: '居中', className: 'fa fa-align-center' },
        { value: 'right', name: '右对齐', className: 'fa fa-align-right' },
        { value: 'justify', name: '两边对齐', className: 'fa fa-align-justify' }
      ]
    }, {
      property: 'text-decoration',
      name: '文字修饰',
      type: 'radio',
      defaults: 'none',
      list: [
        { value: 'none', name: '无', className: 'fa fa-times' },
        { value: 'underline', name: '下划线', className: 'fa fa-underline' },
        { value: 'line-through', name: '中划线', className: 'fa fa-strikethrough' }
      ]
    }, {
      property: 'text-shadow',
      properties: [
        { name: 'X position', property: 'text-shadow-h' },
        { name: 'Y position', property: 'text-shadow-v' },
        { name: 'Blur', property: 'text-shadow-blur' },
        { name: 'Color', property: 'text-shadow-color' }
      ]
    }]
}, {
  name: 'Decorations',
  open: false,
  buildProps: ['opacity', 'background-color', 'border-radius', 'border', 'box-shadow', 'background'],
  properties: [{
    type: 'slider',
    property: 'opacity',
    defaults: 1,
    step: 0.01,
    max: 1,
    min: 0
  }, {
    property: 'border-radius',
    properties: [
      { name: 'Top', property: 'border-top-left-radius' },
      { name: 'Right', property: 'border-top-right-radius' },
      { name: 'Bottom', property: 'border-bottom-left-radius' },
      { name: 'Left', property: 'border-bottom-right-radius' }
    ]
  }, {
    property: 'box-shadow',
    properties: [
      { name: 'X position', property: 'box-shadow-h' },
      { name: 'Y position', property: 'box-shadow-v' },
      { name: 'Blur', property: 'box-shadow-blur' },
      { name: 'Spread', property: 'box-shadow-spread' },
      { name: 'Color', property: 'box-shadow-color' },
      { name: 'Shadow type', property: 'box-shadow-type' }
    ]
  }, {
    property: 'background',
    properties: [
      { name: 'Image', property: 'background-image' },
      { name: 'Repeat', property: 'background-repeat' },
      { name: 'Position', property: 'background-position' },
      { name: 'Attachment', property: 'background-attachment' },
      { name: 'Size', property: 'background-size' }
    ]
  }]
}, {
  name: 'Extra',
  open: false,
  buildProps: ['transition', 'perspective', 'transform'],
  properties: [{
    property: 'transition',
    properties: [
      { name: 'Property', property: 'transition-property' },
      { name: 'Duration', property: 'transition-duration' },
      { name: 'Easing', property: 'transition-timing-function' }
    ]
  }, {
    property: 'transform',
    properties: [
      { name: 'Rotate X', property: 'transform-rotate-x' },
      { name: 'Rotate Y', property: 'transform-rotate-y' },
      { name: 'Rotate Z', property: 'transform-rotate-z' },
      { name: 'Scale X', property: 'transform-scale-x' },
      { name: 'Scale Y', property: 'transform-scale-y' },
      { name: 'Scale Z', property: 'transform-scale-z' }
    ]
  }]
}, {
  name: 'Flex',
  open: false,
  properties: [{
    name: 'Flex Container',
    property: 'display',
    type: 'select',
    defaults: 'block',
    list: [
      { value: 'block', name: 'Disable' },
      { value: 'flex', name: 'Enable' }
    ]
  }, {
    name: 'Flex Parent',
    property: 'label-parent-flex',
    type: 'integer'
  }, {
    name: 'Direction',
    property: 'flex-direction',
    type: 'radio',
    defaults: 'row',
    list: [{
      value: 'row',
      name: 'Row',
      className: 'icons-flex icon-dir-row',
      title: 'Row'
    }, {
      value: 'row-reverse',
      name: 'Row reverse',
      className: 'icons-flex icon-dir-row-rev',
      title: 'Row reverse'
    }, {
      value: 'column',
      name: 'Column',
      title: 'Column',
      className: 'icons-flex icon-dir-col'
    }, {
      value: 'column-reverse',
      name: 'Column reverse',
      title: 'Column reverse',
      className: 'icons-flex icon-dir-col-rev'
    }]
  }, {
    name: 'Justify',
    property: 'justify-content',
    type: 'radio',
    defaults: 'flex-start',
    list: [{
      value: 'flex-start',
      className: 'icons-flex icon-just-start',
      title: 'Start'
    }, {
      value: 'flex-end',
      title: 'End',
      className: 'icons-flex icon-just-end'
    }, {
      value: 'space-between',
      title: 'Space between',
      className: 'icons-flex icon-just-sp-bet'
    }, {
      value: 'space-around',
      title: 'Space around',
      className: 'icons-flex icon-just-sp-ar'
    }, {
      value: 'center',
      title: 'Center',
      className: 'icons-flex icon-just-sp-cent'
    }]
  }, {
    name: 'Align',
    property: 'align-items',
    type: 'radio',
    defaults: 'center',
    list: [{
      value: 'flex-start',
      title: 'Start',
      className: 'icons-flex icon-al-start'
    }, {
      value: 'flex-end',
      title: 'End',
      className: 'icons-flex icon-al-end'
    }, {
      value: 'stretch',
      title: 'Stretch',
      className: 'icons-flex icon-al-str'
    }, {
      value: 'center',
      title: 'Center',
      className: 'icons-flex icon-al-center'
    }]
  }, {
    name: 'Flex Children',
    property: 'label-parent-flex',
    type: 'integer'
  }, {
    name: 'Order',
    property: 'order',
    type: 'integer',
    defaults: 0,
    min: 0
  }, {
    name: 'Flex',
    property: 'flex',
    type: 'composite',
    properties: [{
      name: 'Grow',
      property: 'flex-grow',
      type: 'integer',
      defaults: 0,
      min: 0
    }, {
      name: 'Shrink',
      property: 'flex-shrink',
      type: 'integer',
      defaults: 0,
      min: 0
    }, {
      name: 'Basis',
      property: 'flex-basis',
      type: 'integer',
      units: ['px', '%', ''],
      unit: '',
      defaults: 'auto'
    }]
  }, {
    name: 'Align',
    property: 'align-self',
    type: 'radio',
    defaults: 'auto',
    list: [{
      value: 'auto',
      name: 'Auto'
    }, {
      value: 'flex-start',
      title: 'Start',
      className: 'icons-flex icon-al-start'
    }, {
      value: 'flex-end',
      title: 'End',
      className: 'icons-flex icon-al-end'
    }, {
      value: 'stretch',
      title: 'Stretch',
      className: 'icons-flex icon-al-str'
    }, {
      value: 'center',
      title: 'Center',
      className: 'icons-flex icon-al-center'
    }]
  }]
}
]
